import { render, staticRenderFns } from "./TokenItem.vue?vue&type=template&id=0d435335&scoped=true&"
import script from "./TokenItem.vue?vue&type=script&lang=js&"
export * from "./TokenItem.vue?vue&type=script&lang=js&"
import style0 from "./TokenItem.vue?vue&type=style&index=0&id=0d435335&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d435335",
  null
  
)

export default component.exports